import "../components/aboutusstyles.css";
import Pic1 from "../assets/Picture1.png";
import Pic2 from "../assets/Picture2.png";
import Pic3 from "../assets/Picture3.png";
import { FaTwitter, FaLinkedin, FaFacebook } from 'react-icons/fa';

function AboutUs() {
  return (
    <div className="about-container obj-width">
      <section className="about-section">
        <h1>Our Journey</h1>
        <p>
          Explore Pakistan, owned and managed by Explore Pak Pvt. Ltd., is a
          premier brand in travel and tourism services. We specialize in
          showcasing the hidden gems of Pakistan, offering a unique and
          immersive experience to our clients. With years of expertise in the
          tourism industry, we take pride in curating customized travel
          experiences that exceed our clients' expectations.
        </p>
      </section>

      <section className="about-section">
        <h1>Our Mission</h1>
        <p>
          Our mission is to connect travelers with the breathtaking beauty and
          rich culture of Pakistan, creating memorable experiences that foster
          a deeper understanding and appreciation of the country's heritage.
          We aim to deliver these experiences with transparency, authenticity,
          and cost-effectiveness.
        </p>
      </section>

      <section className="about-section">
        <h1>Our Vision</h1>
        <p>
          To be the leading travel agency in Pakistan, recognized globally for
          our commitment to providing par-excellence services that focus on
          customer satisfaction and sustainable tourism practices.
        </p>
      </section>

      <section className="about-section team-section">
        <h1>Meet Our Team</h1>
        <div className="team-container">
          <div className="team-member">
            <img src={Pic2} alt="Nahail Ahmad" className="team-img" />
            <div className="team-details">
              <h3>Nahail Ahmad</h3>
              <p>Founder & CEO</p>
              <p>
                Nahail is the driving force behind AR City. With over a decade
                of experience in the travel industry, he is passionate about
                creating innovative travel solutions. His vision for AR City is
                to revolutionize how tourists explore the Arctic, ensuring every
                journey is enriching and memorable.
              </p>
              <div className="social-icons">
                <a href="https://x.com/AhNahail" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
                <a href="https://www.linkedin.com/in/nahail-ahmad-full-stack" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="https://www.facebook.com/nahail.ahamd?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
                  <FaFacebook />
                </a>
              </div>
            </div>
          </div>
          <div className="team-member">
            <img src={Pic2} alt="Umer Sadiq" className="team-img" />
            <div className="team-details">
              <h3>Umer Sadiq</h3>
              <p>Head of Operations</p>
              <p>
                Umer is responsible for the seamless execution of AR City's
                operations. With his extensive background in logistics and
                operations management, Umer ensures that every aspect of our
                tours runs smoothly, from booking to execution. His attention to
                detail guarantees that our clients receive top-notch service at
                all times.
              </p>
              <div className="social-icons">
                <a href="https://twitter.com/umer" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
                <a href="https://linkedin.com/in/umer" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="https://facebook.com/umer" target="_blank" rel="noopener noreferrer">
                  <FaFacebook />
                </a>
              </div>
            </div>
          </div>
          <div className="team-member">
            <img src={Pic3} alt="Miraj" className="team-img" />
            <div className="team-details">
              <h3>Miraj Bibi</h3>
              <p>Graphic Designer</p>
              <p>
                Sara leads the design efforts for AR City. Her creativity and
                eye for design help us create visually stunning marketing materials
                and website elements. Sara’s work ensures that our visual
                presentations are engaging and reflect the unique experiences
                AR City offers.
              </p>
              <div className="social-icons">
                <a href="/" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
                <a href="https://www.linkedin.com/in/miraj-bibi-bibi-8a062426a" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="https://www.instagram.com/mi.raj6220?igsh=YzJrenFqNDZ0NnR2" target="_blank" rel="noopener noreferrer">
                  <FaFacebook />
                </a>
              </div>
            </div>
          </div>
          <div className="team-member">
            <img src={Pic1} alt="Memona Maryam" className="team-img" />
            <div className="team-details">
              <h3>Memona Maryam</h3>
              <p>Social Media Manager</p>
              <p>
                Memona oversees AR City's social media presence, crafting engaging
                content and managing interactions with our audience. With a strong
                background in digital marketing, she focuses on building our online
                community and driving growth through effective social media strategies.
              </p>
              <div className="social-icons">
                <a href="https://twitter.com/memona" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
                <a href="https://linkedin.com/in/memona" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="https://facebook.com/memona" target="_blank" rel="noopener noreferrer">
                  <FaFacebook />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
